import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { message } from 'antd';
import { AnswerCheckType, answerTypeList, currencyData } from 'utils/constant';
import { surveyApis } from 'apis/operation/surveyApis';
import CircleButton from 'components/button/CircleButton';
import ToggleButton from 'components/button/ToggleButton';
import GrayBox from 'components/container/GrayBox';

import Message from 'components/etc/Message';
import UtcTimer from 'components/etc/UtcTimer';
import LargeModal from 'components/form/LargeModal';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import RangeDatePicker from 'components/input/RangeDatePicker';
import DefaultSelect from 'components/select/DefaultSelect';
import VerticalTable from 'components/table/VerticalTable';
import SubmitButton from 'components/button/SubmitButton';
import { useTranslation } from 'react-i18next';

const SurveyRegisterModal = ({ visible, setVisible, record, fetchData }) => {
  const { t } = useTranslation();
  const answerCheckType = AnswerCheckType();
  const dateFormat = 'YYYY-MM-DD HH:mm';

  const today = dayjs().format('YYYY-MM-DD HH:mm');
  const [restrictedCounList, setRestrictedCounList] = useState(); //제한 국가
  const [inputData, setInputData] = useState({
    survey_id: 0,
    question_id: 0,
    title: null,
    start_date: today,
    end_date: today,
    currency: 'gem',
    quantity: null,
    is_public: 0,
    exception_country: null,
    question: null,
    answer_kind: 0,
    select_check: 0,
  });
  const [answerList, setAnswerList] = useState([
    {
      answer: null,
      key: 0,
    },
  ]);
  const handleSelectChange = (e, p) => {
    setInputData({ ...inputData, [p.name]: e });
  };
  //multi(제외국가)
  const handleMultiSelectChange = (e) => {
    setInputData({ ...inputData, exception_country: e });
  };

  const handleInputChange = (e) => {
    let { name, value, checked } = e.target;

    if (name === 'exception_country') {
      // inputData.exception_country.replace(/ /g, '');
      setInputData({
        ...inputData,
        [name]: value.toUpperCase().replace(/ /g, ''),
      });
    } else if (name === 'is_public') {
      setInputData({ ...inputData, [name]: checked === true ? 1 : 0 });
    } else {
      setInputData({ ...inputData, [name]: value });
    }
  };
  //무제한 체크
  const handleCheckUnlimited = (e) => {
    if (e.target.checked === true) {
      setInputData({ ...inputData, end_date: '9999-12-31 23:59' });
    } else {
      setInputData({ ...inputData, end_date: today });
    }
  };
  // 답변 리스트 행 추가
  const handleAddRow = (e) => {
    const newDatas = [
      ...answerList,
      {
        answer: null,
        key: answerList.length,
      },
    ];
    setAnswerList(newDatas);
  };

  //답변 리스트 행 삭제
  const handleRemoveRow = (e) => {
    if (answerList.length === 1) {
      return false;
    }

    const newDatas = [...answerList];
    const idx = newDatas.findIndex(function (item) {
      return item.key === Number(e.target.name);
    });
    newDatas.splice(idx, 1);
    newDatas.map((v, i) => (v.key = i)); // id 값을 다시 인덱스대로 돌리기 위해
    setAnswerList(newDatas);
  };
  //답변 리스트 inputChange
  const handleAnswerChange = (e) => {
    setAnswerList(
      answerList.map((v, i) =>
        v.key === Number(e.target.id)
          ? { ...v, answer: Number(e.target.value) }
          : v,
      ),
    );
  };

  const handleSubmit = async () => {
    const res = await surveyApis.surveyRegister(inputData, answerList);
    if (!res) {
      return false;
    }
    message.success('설문조사 항목을 등록하였습니다.');
    fetchData();
    setVisible(false);
  };

  const fetchDropdown = async () => {
    const res = await surveyApis.restrictedCountry();
    res.map((v, i) => {
      v.key = v.country_code;
      v.value = v.country_code;

      v.text = v.country_name;
    });
    setRestrictedCounList(res);
  };
  useEffect(() => {
    fetchDropdown().catch(console.log);
  }, [visible]);
  return (
    <LargeModal
      footer={
        <SubmitButton onClick={handleSubmit}>
          {t('survey.surveyRegisterModal.submit')}
        </SubmitButton>
      }
      title={`${t('survey.surveyRegisterModal.title')} ${
        record
          ? `${t('survey.surveyRegisterModal.correction')}`
          : `${t('survey.surveyRegisterModal.registration')}`
      }`}
      visible={visible}
      onCancel={setVisible}
    >
      <div className='input_wrap survey'>
        <GrayBox left>
          <VerticalTable>
            <>
              <tr>
                <th>{t('survey.surveyRegisterModal.formLeft.surveyName')}</th>
                <td style={{ display: 'flex', alignItems: 'center' }}>
                  <DefaultInput
                    style={{ width: '10rem', marginRight: '2rem' }}
                    value={inputData.title}
                    name='title'
                    type='number'
                    onChange={handleInputChange}
                    placeholder={t(
                      'survey.surveyRegisterModal.formLeft.multilingualID',
                    )}
                  />
                  <Message
                    value={t(
                      'survey.surveyRegisterModal.formLeft.generatedAfterRegistration',
                    )}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('survey.surveyRegisterModal.formLeft.question')}</th>
                <td style={{ display: 'flex', alignItems: 'center' }}>
                  <DefaultInput
                    style={{ width: '10rem', marginRight: '2rem' }}
                    value={inputData.question}
                    name='question'
                    type='number'
                    onChange={handleInputChange}
                    placeholder={t(
                      'survey.surveyRegisterModal.formLeft.multilingualID',
                    )}
                  />
                  <Message
                    value={t(
                      'survey.surveyRegisterModal.formLeft.generatedAfterRegistration',
                    )}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('survey.surveyRegisterModal.formLeft.answerType')}</th>
                <td>
                  <DefaultSelect
                    showSearch={false}
                    optionList={answerTypeList}
                    value={inputData.answer_kind}
                    name='answer_kind'
                    onChange={handleSelectChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  {t('survey.surveyRegisterModal.formLeft.multipleChoice')}
                </th>
                <td>
                  <DefaultRadio
                    name='select_check'
                    onChange={handleInputChange}
                    optionList={answerCheckType}
                    defaultValue={inputData.select_check}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('survey.surveyRegisterModal.formLeft.addAnswer')}</th>
                {answerList?.map((v, i) => (
                  <td
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '90%',
                    }}
                  >
                    <DefaultInput
                      style={{ width: '10rem', marginRight: '2rem' }}
                      type={'number'}
                      value={v.answer}
                      id={i}
                      onChange={handleAnswerChange}
                      placeholder={t(
                        'survey.surveyRegisterModal.formLeft.multilingualID',
                      )}
                    />
                    <Message
                      value={t(
                        'survey.surveyRegisterModal.formLeft.generatedAfterRegistration',
                      )}
                      key={i}
                    />
                    <div style={{ display: 'flex' }}>
                      <CircleButton
                        disabled={answerList.length === 1 && true}
                        style={{ marginLeft: '1rem' }}
                        name={i}
                        onClick={handleRemoveRow}
                      >
                        -
                      </CircleButton>
                      <CircleButton
                        disabled={answerList.length === 10 && true}
                        style={{ marginLeft: '1rem' }}
                        key={i}
                        onClick={handleAddRow}
                      >
                        +
                      </CircleButton>
                    </div>
                  </td>
                ))}
              </tr>
            </>
          </VerticalTable>
        </GrayBox>
        <GrayBox>
          <VerticalTable>
            <tr>
              <th>{t('survey.surveyRegisterModal.formRight.surveyPeriod')}</th>
              <td>
                <div style={{ display: 'flex' }}>
                  <RangeDatePicker
                    showTime
                    value={[
                      dayjs(inputData?.start_date, dateFormat),
                      dayjs(inputData?.end_date, dateFormat),
                    ]}
                  />
                  <CheckboxOneType
                    style={{ marginLeft: '1rem' }}
                    onChange={handleCheckUnlimited}
                    checked={
                      inputData?.end_date.split('-')[0] === String(9999) && true
                    }
                  >
                    {t('survey.surveyRegisterModal.formRight.unlimited')}
                  </CheckboxOneType>
                </div>
                <UtcTimer
                  onGrayBox={true}
                  startDate={inputData?.start_date}
                  endDate={inputData?.end_date}
                />
              </td>
            </tr>
            <tr>
              <th>{t('survey.surveyRegisterModal.formRight.itemReward')}</th>
              <td style={{ display: 'flex' }}>
                <DefaultSelect
                  optionList={currencyData}
                  style={{ marginRight: '1rem' }}
                  placeholder='보상을 선택해주세요.'
                  value={inputData?.currency}
                  name='currency'
                  onChange={handleSelectChange}
                />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <DefaultInput
                    type='number'
                    width={'10rem'}
                    placeholder='0'
                    value={inputData?.quantity}
                    name='quantity'
                    onChange={handleInputChange}
                  />
                  <p style={{ marginLeft: '.5rem' }}>
                    {t('survey.surveyRegisterModal.formRight.items')}
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                {t('survey.surveyRegisterModal.formRight.countryRestriction')}
              </th>
              <td>
                {/* <DefaultInput
                  value={inputData?.exception_country}
                  name="exception_country"
                  onChange={handleInputChange}
                  placeholder="2자리 국가코드 사용, 콤마로 구분합니다.   ex) JA,AR"
                /> */}
                <DefaultSelect
                  onChange={handleMultiSelectChange}
                  mode='multiple'
                  optionList={restrictedCounList}
                  placeholder='제한 국가'
                  name='exception_country'
                />
              </td>
            </tr>
            <tr>
              <th> {t('survey.surveyRegisterModal.formRight.disclosure')}</th>
              <td>
                <ToggleButton
                  name='is_public'
                  onChange={handleInputChange}
                  value={inputData.is_public}
                  checked={inputData?.is_public === 1 ? true : false}
                />
              </td>
            </tr>
          </VerticalTable>
        </GrayBox>
      </div>
    </LargeModal>
  );
};
export default SurveyRegisterModal;
